import firebase from "firebase/app";

import { getCurrentUser } from "./getCurrentUser";

export const setUserActivties = async (newWorkout) => {
  const currentUser = getCurrentUser();
  if (!currentUser) return null;

  const currentDate = new Date().toISOString().split("T")[0];
  const union = firebase.firestore.FieldValue.arrayUnion;

  await firebase
    .firestore()
    .collection("activities")
    .doc(`${currentUser.id}-${currentDate}`)
    .set(
      {
        date: currentDate,
        exercises: union(newWorkout),
        userID: currentUser.id,
        likedByUsers: union(),
      },
      { merge: true }
    )
    .then((doc) => {
      console.info("Document successfully written");
    })
    .catch((e) => {
      console.error("Error writing activities", e);
    });

  await firebase
    .firestore()
    .collection("followers")
    .doc(currentUser.id)
    .update({
      recentActivity: union({ activityID: `${currentUser.id}-${currentDate}`, date: currentDate }),
      lastActivity: currentDate,
    });
};
